import React, { useState, useEffect } from 'react';
import { calendar } from '../../api';
import * as deviceCalendar from '../../utils/deviceCalendar';

// Settings card for coaches/headcoach on the iPhone app: link the phone's own calendar so managers (and the headcoach) can see it.
const IphoneCalendarCard = () => {
  const [status, setStatus] = useState(null); // { connected, syncedAt, eventCount }
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    calendar.getDeviceStatus()
      .then(res => setStatus(res.data))
      .catch(() => setStatus({ connected: false }));
  }, []);

  const handleConnect = async () => {
    setError('');
    setBusy(true);
    try {
      const data = await deviceCalendar.connect();
      setStatus({ connected: true, syncedAt: data.syncedAt, eventCount: data.eventCount });
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'Could not link the iPhone calendar');
    } finally {
      setBusy(false);
    }
  };

  const handleRefresh = async () => {
    setError('');
    setBusy(true);
    try {
      await deviceCalendar.syncIfDue(true);
      const res = await calendar.getDeviceStatus();
      setStatus(res.data);
    } catch (err) {
      setError('Could not refresh right now');
    } finally {
      setBusy(false);
    }
  };

  const handleDisconnect = async () => {
    setError('');
    setBusy(true);
    try {
      await deviceCalendar.disconnect();
      setStatus({ connected: false });
    } catch (err) {
      setError(err?.response?.data?.error || 'Could not unlink the iPhone calendar');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="settings-section">
      <label>iPhone Calendar</label>
      {error && (
        <div className="error-message">
          <span className="error-icon">❌</span>
          <p>{error}</p>
        </div>
      )}
      {status?.connected ? (
        <>
          <p className="password-info">
            ✅ Linked{status.syncedAt ? `, last updated ${new Date(status.syncedAt).toLocaleString([], { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' })}` : ''}
            {status.eventCount != null ? ` (${status.eventCount} events)` : ''}.
            Your managers and head coach can see your calendar. It refreshes whenever you open the app.
          </p>
          <button type="button" className="submit-button" onClick={handleRefresh} disabled={busy}>
            {busy ? 'Updating...' : '🔄 Update now'}
          </button>
          <button type="button" className="cancel-button" onClick={handleDisconnect} disabled={busy}>
            Unlink iPhone Calendar
          </button>
        </>
      ) : (
        <>
          <p className="password-info">
            Link the calendar on this iPhone so your managers and head coach can see your day. Only event times, titles and locations are shared, and only while it is linked.
          </p>
          <button type="button" className="submit-button" onClick={handleConnect} disabled={busy || status === null}>
            {busy ? 'Linking...' : '📅 Link iPhone Calendar'}
          </button>
        </>
      )}
    </div>
  );
};

export default IphoneCalendarCard;
